import React from 'react';
import styled from 'styled-components';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const StyledTabs = styled(Tabs)`
  display: flex;
  justify-content: space-around; // Distribute tabs evenly
  & .MuiTabs-indicator {
    background-color: ${(props) => props.indicatorColor || 'blue'} !important;
  }
`;

const StyledTab = styled(Tab)`
  font-size: ${(props) => props.fontSize || '1rem'} !important;
  color: ${(props) => props.color || 'black'} !important;
  font-family: 'outfit_medium' !important;
  flex-grow: 1; // Make tabs expand equally
  text-align: center;
  text-transform: capitalize !important;

  &.Mui-selected {
    color: ${(props) => props.selectedColor || 'blue'} !important;
    font-family: 'outfit_medium' !important;
  }
`;

const ReusableTabs = ({
  tabs,
  value,
  onChange,
  currentTab,
  tabStyles,
  indicatorColor,
}) => {
  const handleChange = (val) => {
    currentTab(val);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <StyledTabs
        value={value}
        onChange={(e, newValue) => handleChange(newValue)}
        aria-label="wrapped label tabs example"
        indicatorColor={indicatorColor}
        variant="fullWidth"
      >
        {tabs.map((tab) => (
          <StyledTab
            key={tab?.value}
            value={tab?.name}
            label={tab?.label}
            {...tabStyles}
            wrapped
          />
        ))}
      </StyledTabs>
    </Box>
  );
};

export default ReusableTabs;
